/**
 * Enumerates supported identity databases.
 */
export var DatabaseType;
(function (DatabaseType) {
    /** ActiveDirectory (AD) */
    DatabaseType["AD"] = "AD";
    /** Lightweight Directory Service (LDS) */
    DatabaseType["LDS"] = "ADLDS";
})(DatabaseType || (DatabaseType = {}));
//# sourceMappingURL=database.js.map